import Vue from 'vue';

export default () => {
  Vue.use(Instance => {
    (req => {
      req.keys().forEach(key => {
        req(key).default(Instance);
      });
    })(require.context('directives/layout', true, /\.js$/));
  });
};
